export default __webpack_public_path__ + "static/media/environment.d738d881.png";